import(/* webpackMode: "eager" */ "/vercel/path0/app/web/events/[slug]/error.tsx");
